const latestArticle = {
  status: "true",
  message: "取得最新文章",
  total: "3",
  ArticleList: [
    {
      title:
        " IEKView: Riding the AI Trend to Seize Business Opportunities in the Green Transition",
      author: "Silicon Shih",
      url: "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=1&domain=2&rpt_idno=447652488",
      image: `${require("assets/images/home/news-1.jpg")}`,
    },
    {
      title:
        "IEKView：半導體業擴張 AI 扮引擎 專家建議製程創新與綠色轉型雙軌並進",
      author: "黃慧修",
      url: "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=1&domain=2&rpt_idno=518289566",
      image: `${require("assets/images/home/news-2.jpg")}`,
    },
    {
      title: "IEKView：生醫、AI、永續 產業升級三引擎 加速形塑下一波全球競局",
      author: "游佩芬、王嚴璋、呂建興、陳育",
      url: "https://ieknet.iek.org.tw/iekrpt/rpt_detail.aspx?indu_idno=1&domain=2&rpt_idno=515035866",
      image: `${require("assets/images/home/news-3.jpg")}`,
    },
  ],
};

export default latestArticle;
